import { render } from "./Project1View.vue?vue&type=template&id=330a9d86&scoped=true&ts=true"
import script from "./Project1View.vue?vue&type=script&lang=ts"
export * from "./Project1View.vue?vue&type=script&lang=ts"

import "./Project1View.vue?vue&type=style&index=0&id=330a9d86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330a9d86"]])

export default __exports__